module.exports = __webpack_public_path__ + "img/lize04.5887271a.png";